import api from "./api";
import { notifyEngagement } from "../utils/engagementEvents";

const unwrap = (payload) => payload?.data ?? payload;

// The catalog is static per deployment, so fetch it once and share.
let optionsPromise = null;

export const reactionsService = {
  getOptions: async () => {
    if (!optionsPromise) {
      optionsPromise = api
        .get("/api/v1/reactions/options")
        .then((res) => unwrap(res.data))
        .catch((err) => {
          optionsPromise = null; // allow retry on failure
          throw err;
        });
    }
    return optionsPromise;
  },

  getSummary: async (targetType, targetIds) => {
    if (!targetIds || targetIds.length === 0) return [];
    const params = new URLSearchParams({ target_type: targetType });
    targetIds.forEach((id) => params.append("target_ids", id));
    const response = await api.get(`/api/v1/reactions/summary?${params}`);
    return unwrap(response.data) || [];
  },

  addReaction: async (targetType, targetId, reactionKey) => {
    const response = await api.put(
      `/api/v1/reactions/${targetType}/${targetId}/${reactionKey}`
    );
    // Fired here rather than in the component so all three credit sources
    // announce themselves from the same layer; removing a reaction earns
    // nothing, so removeReaction stays silent.
    notifyEngagement("reaction");
    return unwrap(response.data);
  },

  removeReaction: async (targetType, targetId, reactionKey) => {
    const response = await api.delete(
      `/api/v1/reactions/${targetType}/${targetId}/${reactionKey}`
    );
    return unwrap(response.data);
  },
};

export default reactionsService;
